import { LoadingIndicator } from '@/shared/ui/loading-indicator'
import './setTimezonePage.scss'
import { useEffect, useState } from 'react'
import { api } from '@/shared/api'
import { SetTimezoneDto } from '@synapex/shared/dist/dtos/telegram'
import { telegramGetPeerTmeUrl } from '@synapex/shared2/telegram'

export const SetTimezonePage = () => {
    const [timezone, setTimezone] = useState<string | null>(null)
    const [userId, setUserId] = useState<string | null>(null)
    const [username, setUsername] = useState<string | null>(null)
    const [apiResponse, setApiResponse] = useState<boolean | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        async function gettimezone() {
            const userTimezone =
                Intl.DateTimeFormat().resolvedOptions().timeZone
            setTimezone(userTimezone)

            const userIdFromUrl = new URLSearchParams(
                window.location.search
            ).get('id')
            const usernameFromUrl = new URLSearchParams(
                window.location.search
            ).get('username')
            const prevMessageId = new URLSearchParams(
                window.location.search
            ).get('prev_message_id')

            setUserId(userIdFromUrl)
            setUsername(usernameFromUrl)

            if (userIdFromUrl) {
                // const response = await fetch(`${import.meta.env.VITE_SERVER_ROOT}/telegram/settimezone_bot`, {
                //     method: 'POST',
                //     headers: {
                //         'Content-Type': 'application/json',
                //     },
                //     body: JSON.stringify({
                //         message: {
                //             message_id: Date.now(),
                //             date: Math.floor(Date.now() / 1000),
                //             text: "/settimezone",
                //             timezone: userTimezone,
                //             chat: {
                //                 id: parseInt(userIdFromUrl),
                //                 type: "private",
                //                 first_name: "Alexandr",
                //                 username: usernameFromUrl,
                //             },
                //             prev_message_id: prev_message_id,
                //         }
                //     })
                // });

                const response = await api.post<boolean | null>(
                    `/telegram/settimezone`,
                    {
                        userId: userIdFromUrl,
                        prevMessageId: prevMessageId,
                        timezone: userTimezone,
                    } as SetTimezoneDto
                )

                setApiResponse(response)

                // if (response.ok) {
                //     console.log('Message sent to bot successfully.');
                // } else {
                //     console.error('Failed to send message to bot.');
                // }
                window.location.href = telegramGetPeerTmeUrl({
                    username: import.meta.env.VITE_BOT_USERNAME,
                }).href
            }

            setIsLoading(false)
        }

        gettimezone()
    }, [])

    const renderApiResponseMessage = () => {
        if (apiResponse) {
            if (apiResponse) {
                return <p>✅ You can close this page.</p>
            } else {
                return <p>⛔ Something went wrong.</p>
            }
        }
        return <p>...</p>
    }

    return (
        <section className="login-page">
            {isLoading && !apiResponse && (
                <>
                    <LoadingIndicator />
                    {/* <p>Redirecting you back to the bot with your timezone...</p> */}
                </>
            )}

            <div className="debug-info">
                {/* <h3>Debug Information:</h3> */}
                <p>
                    <strong>Timezone:</strong> {timezone}
                </p>
                <p>
                    <strong>User ID:</strong> {userId}
                </p>
                <p>
                    <strong>Username:</strong> {username}
                </p>

                <p>
                    <strong>ApiResponse:</strong> {renderApiResponseMessage()}
                </p>
            </div>

            {isLoading && <p>Loading your data...</p>}
        </section>
    )
}
